import { DataTableSearch } from '@/components/ui/table/data-table-search';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { downloadCSV } from '@/lib/download-file';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCategoryDataFilters } from './use-category-data-filters';
import { memo } from 'react';

interface CategoryDataTableActionProps {
  data: any[];
}

function CategoryDataTableAction({ data }: CategoryDataTableActionProps) {
  const navigate = useNavigate();
  const { searchQuery, setSearchQuery, sort, setSort, resetFilters, isAnyFilterActive } = useCategoryDataFilters();

  const sortingOptions = [
    { label: 'Most Recent', value: 'asc' },
    { label: 'Least Recent', value: 'desc' }
  ];

  const handleSortingChange = (value: string) => {
    setSort(value);
  };

  const handleDownload = async () => {
    downloadCSV(data, 'category-data', {
      nestedFields: ['tags']
    });
  };

  return (
    <div className='flex flex-wrap items-center justify-between gap-4 px-5'>
      <DataTableSearch
        searchKey='categories'
        searchQuery={searchQuery || ''}
        setSearchQuery={setSearchQuery as any}
        setPage={async () => new URLSearchParams()}
        className='bg-[#F7F7F7]'
      />

      <div className='flex items-center gap-4'>
        {/* Sorting Select */}
        <div className='flex items-center gap-2'>
          <p className='text-sm font-medium text-foreground'>Sort By</p>
          <Select
            onValueChange={handleSortingChange}
            value={sort || undefined}
          >
            <SelectTrigger className='w-[150px]'>
              <SelectValue placeholder='Select sorting' />
            </SelectTrigger>
            <SelectContent>
              {sortingOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {/* Add Category Button */}
        <Button onClick={() => navigate('/dashboard/data/add')}>
          <Plus className="mr-2 h-4 w-4" />
          Add Category
        </Button>

        {/* Export Button */}
        <Button
          variant="outline"
          onClick={handleDownload}
          disabled={!data || data.length === 0}
        >
          Export Data
        </Button>

        {/* Reset Filters Button */}
        {isAnyFilterActive && (
          <Button
            variant="outline"
            onClick={resetFilters}
          >
            Reset Filters
          </Button>
        )}
      </div>
    </div>
  );
}

export default memo(CategoryDataTableAction);